import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faFileInvoice,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/stockEntrySlice.jsx"
import { typographyClasses } from "@mui/material"



const StockEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, CurrencySetting } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const [pageActionType, setPageActionType] = useState("")
  const { strdtype, sptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selBillType, setSelBillType] = useState('O')
  const [selTradeOf, setSelTradeOf] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard)
    disapatch(resetDetailParams())

    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(strdtype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(sptype))
    )
      navigate(linksUrl.dashboard)

    if (strdtype && strdtype != "" || sptype && sptype != "") {

      let t_trdtype = strdtype.toLowerCase()
      //let t_btype = btype.toLowerCase()
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_ptype = ''


      if (sptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'


      if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        setnaviCode(linksUrl.stockEntry.polishDiamond)
      }
      else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        setnaviCode(linksUrl.stockEntry.roughDiamond)
      }
      else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rejection
        t_entryLabel = "Rejection Diamond "
        setnaviCode(linksUrl.stockEntry.rejectDiamond)
      }

      setSelTradeOf(t_tradeof)
      //setSelBillType('O')
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      funFilterData(t_tradeof, t_ptype, null, null, 0, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: 'O', TradeOf: t_tradeof })
    }


  }, [strdtype, sptype])



  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.stockEntry.fetch,
    queryKey: "Stock Data List",

  })
  const funFilterData = (tradeof, pkttype, lotno, pktno, ismfgno, scode, qcode, shcode, szcode, itemcode, fromdate, todate) => {
    // console.log(tradeof, pkttype, lotno, pktno, ismfgno, scode, qcode, shcode, fromdate, todate)
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: selBillType,
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : '',
        l_code: lotno,
        pkt_no: pktno,
        is_mfgno: ismfgno,
        s_code: scode,
        q_code: qcode,
        sz_code: szcode,
        sh_code: shcode,
        from_date: fromdate,
        to_date: todate,
        item_code: itemcode
      }
    })
    //q_code, sz_code, s_code, sh_code, l_code, pkt_no, is_mfgno, item_code, from_date, to_date
  }


  const onSuccessDelete = (data) => {
    setItemToDelete("")

    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Stock can't be delete as it locked", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData(selTradeOf, selPktType, null, null, null, null, null, null, null, null, null, null);
      }
    }
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.stockEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmt",
      }),
    [data]
  )
  let totalAmtD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmtD",
      }),
    [data]
  )
  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Pcs",
      }),
    [data]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Weight",
      }),
    [data]
  )


  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    //"Party_Name",
    "Chal_No",
    "StockDetail",
    "Pcs",
    "Weight",
    "NetAmt",
    "NetAmtD",
    "Chal_Date",
    "Account_Name",
    "Stock"

  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "MEMO NO",
      uid: "Chal_No",
    },
     {
      name: "Details",
      uid: "StockDetails",
    },
    {
      name: "PCS",
      uid: "Pcs",
    },
    {
      name: "WEIGHT",
      uid: "Weight",
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      type: COLUMN_TYPE.number,
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      type: COLUMN_TYPE.number,
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
    },
    {
      name: "STOCK",
      uid: "Stock",
    },
  ]
  const [exportCols, setExportCols] = useState(exportColumns)
  let downloadDataFooter = {
    Memo_No: "",
    Details:"",
    Pcs: "Total:" + totalPcs,
    Weight: "Total:" + totalWeight,
    NetAmt: "Total: " + totalAmt,
    NetAmtD: "Total: " + totalAmtD,
    Date: "",
    Account: "",
    Stock: ""
  }
  const [exportFooter, setExportFooter] = useState(downloadDataFooter)

  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = ""
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = "NetAmtD"
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = "NetAmt"
      else
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)

      if (AmtColumn != "") {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)
      }
    }
  }, [CurrencySetting])

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "MEMO NO",
      uid: "Chal_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
     {
      name: "Details",
      uid: "StockDetail",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Pcs",
      uid: "Pcs",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPcs,
      },
    },
    {
      name: "Weight",
      uid: "Weight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalWeight,
      },
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmtD,
      },
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "STOCK",
      uid: "Stock",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]

  const handleConfirmBox = (data) => {

    if (data) {
      if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            bill_type: itemToDelete.bill_type,
            trade_of: selTradeOf
          }
        })
      }
      else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setDetailParams(itemToEdit))
        disapatch(setNewEntryMode(false))
        if (selPktType == 'MIX')
          navigate(naviCode + strdtype + "/" + sptype + linksUrl.mixEntry + linksUrl.stockEntry.createStockEntry)
        else
          navigate(naviCode + strdtype + "/" + sptype + linksUrl.stockEntry.createStockEntry)
      }
    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of

        }
         setItemToEdit(obj)


      },
      type: ROW_ACTION_BTN_TYPE.link,
    },

    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToEdit("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, bill_type: row.Bill_Type })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + strdtype + "/" + sptype + linksUrl.mixEntry + linksUrl.stockEntry.createStockEntry)
    else
      navigate(naviCode + strdtype + "/" + sptype + linksUrl.stockEntry.createStockEntry)

  }
  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Shape,
    ENUM_ADVSEARCH_PARAM.Purity,
    ENUM_ADVSEARCH_PARAM.Color,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    ENUM_ADVSEARCH_PARAM.LotNo,
    ENUM_ADVSEARCH_PARAM.PktNo,
    ENUM_ADVSEARCH_PARAM.IsMfgNo,
    ENUM_ADVSEARCH_PARAM.Size,
    ENUM_ADVSEARCH_PARAM.Item
  ]

  const handleFilterChange = (newFilters) => {

    //console.log('Received filters in parent:', newFilters);
    setSelAdvanceFilter(newFilters)
    funFilterData(selTradeOf, selPktType,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LotNo) ? newFilters[ENUM_ADVSEARCH_PARAM.LotNo] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.PktNo) ? newFilters[ENUM_ADVSEARCH_PARAM.PktNo] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.IsMfgNo) ? newFilters[ENUM_ADVSEARCH_PARAM.IsMfgNo] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,

    )

  };

  return (
    <div>

      {(itemToDelete || itemToEdit) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}

      <MainContainer
        pageName={entryLabel + ` Stock ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[entryLabel + " Stock ", selPktType == 'SNG' ? "Single Packet" : selPktType,]}
      >

        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          downloadFileName={entryLabel + "stock-List"}
          showAdvanceFilter={true}
          onFilterChange={handleFilterChange}
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}

          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default StockEntryMaster
